<div class="support-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <div class="support-content">
    <div class="support-layout">
      <!-- Sección izquierda: Formulario de contacto -->
      <div class="contact-section">
        <div class="contact-card">
          <h2 class="section-title">Envíanos un mensaje</h2>
          
          <form (ngSubmit)="onSubmit()" class="contact-form">
            <div class="form-group">
              <label for="nombre" class="form-label">Nombre</label>
              <input 
                type="text" 
                id="nombre"
                name="nombre"
                [(ngModel)]="formData.nombre"
                class="form-input"
                placeholder="Tu nombre completo"
              />
            </div>

            <div class="form-group">
              <label for="email" class="form-label">Email</label>
              <input 
                type="email" 
                id="email"
                name="email"
                [(ngModel)]="formData.email"
                class="form-input"
                placeholder="tu@email.com"
              />
            </div>

            <div class="form-group">
              <label for="asunto" class="form-label">Asunto</label>
              <input 
                type="text" 
                id="asunto"
                name="asunto"
                [(ngModel)]="formData.asunto"
                class="form-input"
                placeholder="¿En qué podemos ayudarte?"
              />
            </div>

            <div class="form-group">
              <label for="mensaje" class="form-label">Mensaje</label>
              <textarea 
                id="mensaje"
                name="mensaje"
                [(ngModel)]="formData.mensaje"
                class="form-textarea"
                rows="6"
                placeholder="Describe tu consulta o problema..."
              ></textarea>
            </div>

            <button type="submit" class="submit-button">
              Enviar Mensaje
            </button>
          </form>
        </div>
      </div>

      <!-- Sección derecha: FAQ -->
      <div class="faq-section">
        <div class="faq-card">
          <h2 class="section-title">Preguntas Frecuentes</h2>
          
          <div class="faq-list">
            <div *ngFor="let faq of faqs" class="faq-item">
              <div class="faq-question">
                <svg class="faq-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <span class="faq-question-text">{{ faq.question }}</span>
              </div>
              <p class="faq-answer">{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección de contacto de soporte -->
    <div class="support-info">
      <div class="support-info-card">
        <div class="support-info-content">
          <svg class="support-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <div class="support-info-text">
            <p class="support-email">puntodefuga@support.com</p>
            <p class="support-response">Respondemos en 24 horas</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="footer-container">
      <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
      <div class="footer-links">
        <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
        <a routerLink="/support" data-i18n="footerContact">Soporte</a>
      </div>
    </div>
  </footer>
</div>
